// extracted by mini-css-extract-plugin
export {};
    if(module.hot) {
      // 1785990983719
      var cssReload = require("/home/vsts/work/1/s/client/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":false});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);
    }
  